// extracted by mini-css-extract-plugin
module.exports = {"LandingPagePosts":"LandingPagePosts_LandingPagePosts__PricB","title":"LandingPagePosts_title__Eop1O"};